import { z } from "zod"
import { textAreaDefaultMaxLength } from "@/models/common"
import { Language } from "@/types/__generated__/union-types"

const LaboratoryPrescriptionSchema = z
  .object({
    language: z.custom<Exclude<Language, "ITALIAN">>((language) => !!language, {
      message: "common.fieldErrorList.requiredField",
    }),
    pointOfCareExaminations: z.array(z.string()),
    externalExaminations: z.array(z.string()),
    additionalRemark: z
      .string()
      .max(textAreaDefaultMaxLength, { message: "common.fieldErrorList.characterLimit" })
      .optional()
      .nullable(),
    isDoc2u: z.boolean(),
  })
  .superRefine(({ pointOfCareExaminations, externalExaminations, isDoc2u }, ctx) => {
    if (!isDoc2u && pointOfCareExaminations.length === 0 && externalExaminations.length === 0) {
      ctx.addIssue({
        code: "custom",
        path: ["pointOfCareExaminations"],
        message: "common.fieldErrorList.requiredField",
      })
    }
  })

type LaboratoryPrescription = z.infer<typeof LaboratoryPrescriptionSchema>

export { type LaboratoryPrescription, LaboratoryPrescriptionSchema }
